import React, { useState, useEffect } from 'react';
import { listFlows } from '../api/flowsApi';
import { User, Cpu, Clock } from 'lucide-react';

const FlowPickerModal = ({ show, onClose, onSelect }) => {
  const [flows, setFlows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!show) return;
    setLoading(true);
    setError(null);
    listFlows()
      .then(setFlows)
      .catch(() => setError('Failed to load flows'))
      .finally(() => setLoading(false));
  }, [show]);

  if (!show) return null;

  const fmt = (dt) => {
    if (!dt) return '';
    const d = new Date(dt);
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="settings-modal-overlay" onClick={onClose}>
      <div
        className="settings-modal flow-picker-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ minWidth: 480, maxWidth: 640 }}
      >
        <h2>Load Flow</h2>

        {loading && <p style={{ color: '#6b7280', fontSize: 14 }}>Loading flows…</p>}
        {error && <p style={{ color: '#ef4444', fontSize: 14 }}>{error}</p>}

        {!loading && !error && flows.length === 0 && (
          <p style={{ color: '#6b7280', fontSize: 14 }}>No saved flows yet.</p>
        )}

        <div className="flow-picker-list">
          {flows.map((f) => (
            <button
              key={f.id}
              className="flow-picker-item"
              onClick={() => onSelect(f)}
            >
              <div className="flow-picker-item-header">
                {f.human_authored
                  ? <User size={13} style={{ color: '#6366f1' }} />
                  : <Cpu size={13} style={{ color: '#10b981' }} />}
                <span className="flow-picker-name">{f.name || 'Untitled flow'}</span>
                {f.role && (
                  <span className="flow-picker-role">{f.role}</span>
                )}
              </div>
              <div className="flow-picker-meta">
                <Clock size={11} />
                <span>{fmt(f.updated_at)}</span>
                <span>·</span>
                <span>{f.node_count} node{f.node_count !== 1 ? 's' : ''}</span>
              </div>
            </button>
          ))}
        </div>

        <button onClick={onClose} style={{ marginTop: 12 }}>Close</button>
      </div>
    </div>
  );
};

export default FlowPickerModal;
